/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.helpers = app.helpers || {};

(function () {
  'use strict';
  
  app.helpers.isMobileHelper = {
    
    /**
     * Проверяет, является ли телефон мобильным.
     * @param  phoneCode, phoneNumberLength.
     * @returns {boolean}
     */
    isMobile: function (phoneCode, phoneNumberLength) {
      var country = app.countryFlag.attributes.nameEn,
        check;
      /* Сделал такую конструкцию на случай добавления стран, в которые будут отправляться смс */
      switch (country) {
        case 'russia': {
          check = app.countryFlag.attributes.countryId === 643 && phoneNumberLength === 11 && phoneCode >= 900 && phoneCode <= 999;
          break;
        }
        default: {
          check = false;
        }
      }
      return check;
    }
  };
  
})();

}.call(window));